import { siApple, siGooglemaps, siYelp } from "simple-icons";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
const platforms = [{
  label: "Google Maps",
  kind: "google"
}, {
  label: "Apple Maps",
  kind: "apple",
  icon: siApple
}, {
  label: "Bing",
  kind: "bing"
}, {
  label: "Gelbe Seiten",
  kind: "gelbe"
}, {
  label: "Yelp",
  kind: "yelp",
  icon: siYelp
}, {
  label: "Das Örtliche",
  kind: "oertliche"
}];
function BrandIcon({
  icon,
  className
}) {
  return <svg viewBox="0 0 24 24" aria-hidden className={className} fill="currentColor">
      <path d={icon.path} />
    </svg>;
}
function PlatformLogo({
  platform
}) {
  if (platform.kind === "google") {
    return <div className="flex items-center gap-2">
        <BrandIcon icon={siGooglemaps} className="h-9 w-9 text-google-red" />
        <span className="text-xl font-semibold">
          <span className="text-google-blue">G</span><span className="text-google-red">o</span><span className="text-google-yellow">o</span><span className="text-google-blue">g</span><span className="text-google-green">l</span><span className="text-google-red">e</span>
        </span>
      </div>;
  }
  if (platform.kind === "apple") {
    return <div className="flex items-center gap-2 text-xl font-semibold text-foreground"><BrandIcon icon={platform.icon} className="h-8 w-8" />Maps</div>;
  }
  if (platform.kind === "bing") {
    return <div className="flex items-center gap-2 text-2xl font-semibold text-foreground"><span className="text-3xl font-bold text-bing">b</span>Bing</div>;
  }
  if (platform.kind === "gelbe") {
    return <div className="flex items-center gap-2 font-bold text-foreground"><span className="flex h-10 w-10 items-center justify-center rounded-sm bg-directory-yellow text-lg text-directory-yellow-ink">G</span><span className="leading-tight">Gelbe<br />Seiten</span></div>;
  }
  if (platform.kind === "yelp") {
    return <div className="flex items-center gap-2 text-2xl font-bold text-foreground">yelp<BrandIcon icon={platform.icon} className="h-8 w-8 text-yelp" /></div>;
  }
  return <div className="text-center text-lg font-bold leading-tight text-directory-blue">Das Örtliche<span className="mx-auto mt-1 block h-1 w-16 bg-directory-red" /></div>;
}
export function PlatformCoverage() {
  const t = useT();
  return <section className="overflow-hidden bg-background py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">
              {t.platforms.eyebrow}
            </p>
            <h2 className="mt-4 text-2xl font-bold text-foreground sm:text-3xl">
              {t.platforms.title}
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">
              {t.platforms.lead}
            </p>
          </div>
        </Reveal>

        <div className="relative mt-12">
          <div className="absolute left-[8%] right-[8%] top-1/2 hidden h-px bg-border md:block" aria-hidden />
          <ul className="relative grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-6 md:gap-4">
            {platforms.map((platform, index) => <Reveal as="li" key={platform.label} delay={index * 55}>
                <div className="flex min-h-40 flex-col items-center justify-center rounded-lg border border-border bg-card px-3 py-5 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/25 hover:shadow-md motion-reduce:hover:translate-y-0">
                  <div className="flex min-h-12 items-center justify-center" aria-label={`${platform.label} logo`}>
                    <PlatformLogo platform={platform} />
                  </div>
                  <span className="mt-1 text-[11px] text-muted-foreground">{t.platforms.checked}</span>
                </div>
              </Reveal>)}
          </ul>
        </div>

        <Reveal>
          <div className="mx-auto mt-8 flex max-w-xl items-center justify-center gap-3 text-center text-sm text-muted-foreground">
            <span className="h-px flex-1 bg-border" aria-hidden />
            <span className="font-semibold text-foreground">{t.platforms.more}</span>
            <span className="h-px flex-1 bg-border" aria-hidden />
          </div>
        </Reveal>
      </div>
    </section>;
}